__turbopack_context__.v({
  "container": "resource-aside-module__fRkDEa__container",
  "resourcesAside": "resource-aside-module__fRkDEa__resourcesAside",
  "resourcesAsideSnippet": "resource-aside-module__fRkDEa__resourcesAsideSnippet",
  "resourcesAsideSnippetThumbnail": "resource-aside-module__fRkDEa__resourcesAsideSnippetThumbnail",
  "resourcesAsideSnippetTitle": "resource-aside-module__fRkDEa__resourcesAsideSnippetTitle",
  "resourcesAsideSnippetTitleContainer": "resource-aside-module__fRkDEa__resourcesAsideSnippetTitleContainer",
  "resourcesAsideTitle": "resource-aside-module__fRkDEa__resourcesAsideTitle",
  "snippetCTA": "resource-aside-module__fRkDEa__snippetCTA",
  "snippetContentContainer": "resource-aside-module__fRkDEa__snippetContentContainer",
  "snippetSubTitle": "resource-aside-module__fRkDEa__snippetSubTitle",
});
